import { render } from "./Redefining.vue?vue&type=template&id=6923523d"
import script from "./Redefining.vue?vue&type=script&lang=js"
export * from "./Redefining.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__